import { render, staticRenderFns } from "./NbIotDetail.vue?vue&type=template&id=7d4dae6d&"
import script from "./NbIotDetail.vue?vue&type=script&lang=js&"
export * from "./NbIotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports